<script setup lang="ts">
interface PreviewPlaceholderProps {
  title: string
  description?: string
}

const props = withDefaults(defineProps<PreviewPlaceholderProps>(), {
  description: ''
})
</script>

<template>
  <div
    class="flex flex-col items-center justify-center gap-1 border-dashed border-slate-300 bg-slate-100 px-4 text-center text-slate-500"
    aria-hidden="true"
  >
    <p class="text-sm font-medium uppercase tracking-wide">{{ props.title }}</p>
    <p v-if="props.description" class="text-xs">{{ props.description }}</p>
  </div>
</template>
